__turbopack_context__.v({
  "arrow": "AkPYrq_arrow",
  "back": "AkPYrq_back",
  "backdrop": "AkPYrq_backdrop",
  "buttons": "AkPYrq_buttons",
  "close": "AkPYrq_close",
  "forward": "AkPYrq_forward",
  "modal": "AkPYrq_modal",
});
